import React from 'react';
import { logoAilosofy } from '../../assets/logos';

export function Logo() {
  return (
    <div className="flex items-center space-x-2">
      <div className="h-16 w-16 rounded-xl overflow-hidden shadow-md flex-shrink-0">
        <img src={logoAilosofy} alt="AiLosofy Logo" className="h-full w-full object-cover" />
      </div>
      <span className="text-xl font-bold bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
        AiLosofy
      </span>
    </div>
  );
}